<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { closeModal } from 'svelte-modals';

    import SearchInput from '../../shared/SearchInput.svelte';
    import JobList from '../Location/JobList.svelte';
    import { type FilterListType } from '../../../stores/filter';
    import { Location } from '../Location/Location';

    export let isOpen: boolean = false;

    export let alreadyUsedItems: number[] = [];
    export let onClick: (location: Location) => void;

    let filter: FilterListType = {
        queries: {},
        quickSearch: '',
        managerStorageKey: 'jobList-modal',
        onlyLowQuality: false,
    };

    function onSelect(location: Location) {
        closeModal();
        onClick(location);
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents" style="height: 600px; width: 800px; ">
            <div
                style="display: flex; padding: 20px; justify-content: space-between; align-items: center; width: 100%; "
            >
                <div style="font-size: 16px;">{$_('Select point')}</div>
                <div>
                    <SearchInput
                        placeholder={$_('City, street, name')}
                        query={filter.quickSearch}
                        onChange={q => {
                            filter.quickSearch = q;
                            filter = filter;
                        }}
                        onKeyup={q => {
                            filter.quickSearch = q;
                            filter = filter;
                        }}
                        debounceTime={200}
                    />
                </div>
            </div>
            <div
                style="overflow: scroll; display: flex; flex: 1; flex-direction: column; justify-content: flex-start; align-items: center; column-gap: 10px; padding:20px; width: 100%; height: 100%;"
            >
                <JobList
                    onClick={onSelect}
                    showFilter={false}
                    bind:filter
                    onChangeFilter={filter => {
                        console.log('filter', filter);
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .contents {
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        align-items: center;
        padding-top: 40px;
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: flex-end;
        column-gap: 10px;
    }

    :global(.job-list) {
        width: 800px;
    }
</style>
